import { Box, Heading, VStack, Text,Image,SimpleGrid,useColorModeValue , useBreakpointValue,useToast,
    Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Icon,
  Flex,
  Button,
  Badge,
  Divider,
} from '@chakra-ui/react';
import PublicLayout from "./Layouts/PublicLayout";
import { CheckCircleIcon } from "@chakra-ui/icons";
import { HStack } from "@chakra-ui/react";

//import bandpic from "../../resources/pexels-pixabay-289737.jpg";
import bandpic from "../../resources/EDUVIC Landing page.png";

import { useNavigate } from "react-router-dom";
import { useState,useCallback } from "react";

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom'; 

import { CategoryDetails } from '../../Platform/Common/types';
import { MasterPromotion } from '../../Platform/Common/types';
import axios from "axios";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { FaRegLightbulb,FaUserGraduate, FaRoute, FaExternalLinkAlt, FaUsers } from "react-icons/fa";


import {
  FaCheckCircle,
  FaChartLine,
  FaClock,
  FaBrain,
  FaLaptopCode,
  FaBullseye,
} from "react-icons/fa";
import B2CMarkdownLongText from '../Components/B2CMarkDownLongText';
import B2CVideoEmbed from '../Components/B2CVideoEmbed';

const B2CLandingPage = () => {

  const navigate = useNavigate();
  const [hover, setHover] = useState(false);
  const handleNavigation = (path: string) => {
    navigate(path);
  };

  const theme = useColorModeValue("light", "dark");
  const isMobile = useBreakpointValue({ base: true, md: false });

   const [categories, setCategories] = useState<CategoryDetails[]>([]);
  
    const toast = useToast();
    const tableHeaderbg = useColorModeValue("gray.200", "gray.700");

    const [masterPromo, setMasterPromo] = useState<MasterPromotion | null>(null);
  
    // Fetch enrolled students when tenant ID is set
  const fetchCategories = useCallback(async () => {
    try {
      const apiUrl = process.env.REACT_APP_API_URL || 'https://default-url.com';
      const response = await axios.get(`${apiUrl}/b2c/public/categories`);
      setCategories(response.data);
    } catch (error) {
      console.error("Failed to load B2C Categories", error);
    }
  }, []);
  
  useEffect(() => {
    fetchCategories();
  }, [fetchCategories]);

  const fetchMasterPromotion = useCallback(async () => {
  try {
    const apiUrl = process.env.REACT_APP_API_URL || 'https://default-url.com';
    const response = await axios.get(`${apiUrl}/b2c/public/master-promotion`);
    setMasterPromo(response.data || null);
  } catch (error) {
    // A missing/404 response just means no active master promotion exists --
    // not an error state worth surfacing to the visitor.
    setMasterPromo(null);
  }
}, []);

useEffect(() => {
  fetchMasterPromotion();
}, [fetchMasterPromotion]);

const handleCopyCoupon = async (code: string) => {
  try {
    await navigator.clipboard.writeText(code);
    toast({ title: "Coupon code copied", status: "success", duration: 2000, isClosable: true });
  } catch (err) {
    toast({ title: "Could not copy automatically", description: code, status: "info", duration: 4000, isClosable: true });
  }
};
  
  const categoryBg = useColorModeValue("teal.100", "gray.800");
  const domainBg = useColorModeValue("blue.100", "gray.800");

const location = useLocation();

useEffect(() => {
  if (!location.hash) return;

  const scrollToSection = () => {
    const element = document.querySelector(location.hash);

    if (element) {
      const yOffset = -80;

      const yPosition =
        element.getBoundingClientRect().top +
        window.scrollY +
        yOffset;

      window.scrollTo({
        top: yPosition,
        behavior: "smooth",
      });
    }
  };

  const timer = window.setTimeout(scrollToSection, 150);

  return () => {
    window.clearTimeout(timer);
  };
}, [location.hash]);

useEffect(() => {
  if (!location.hash) {
    window.scrollTo(0, 0);
  }
}, [location.pathname, location.hash]);

useEffect(() => {
  const previousBehavior = window.history.scrollRestoration;

  window.history.scrollRestoration = "manual";

  return () => {
    window.history.scrollRestoration = previousBehavior;
  };
}, []);

const COLOR_THEMES = [
  "purple",
  "blue",
  "cyan",
  "orange",
  "teal",
  "pink",
  "yellow",
  "green"
];

const getThemeByIndex = (index: number, mode: "light" | "dark") => {
  const color = COLOR_THEMES[index % COLOR_THEMES.length];

  return {
    accent: color,
    lightBg: mode === "light" ? `${color}.50` : "gray.900",
    border: mode === "light" ? `${color}.300` : "gray.700",
    strip: `${color}.500`,
    text: `${color}.600`,
  };
};


// const markdownComponents = {
//   h1: ({ children }: any) => (
//     <Heading as="h1" size="sm" mb={2}>{children}</Heading>
//   ),
//   h2: ({ children }: any) => (
//     <Heading as="h2" size="sm" fontWeight="semibold" mb={2}>{children}</Heading>
//   ),
//   h3: ({ children }: any) => (
//     <Heading as="h3" size="xs" fontWeight="semibold" mb={2}>{children}</Heading>
//   ),
//   p: ({ children }: any) => <Text mb={2}>{children}</Text>,
//   ul: ({ children }: any) => <Box as="ul" pl={4} mb={2}>{children}</Box>,
//   li: ({ children }: any) => <Box as="li" mb={1}>{children}</Box>,
//   strong: ({ children }: any) => (
//     <Text as="span" fontWeight="bold">{children}</Text>
//   ),
// };

const markdownComponents = {
  h1: ({ children }: any) => (
    <Heading
      as="h1"
      size="sm"
      mb={2}
      lineHeight="1.3"
    >
      {children}
    </Heading>
  ),

  h2: ({ children }: any) => (
    <Heading
      as="h2"
      size="sm"
      fontWeight="semibold"
      mb={2}
      mt={3}
      lineHeight="1.3"
    >
      {children}
    </Heading>
  ),

  h3: ({ children }: any) => (
    <Heading
      as="h3"
      size="xs"
      fontWeight="semibold"
      mb={2}
      mt={2}
      lineHeight="1.3"
    >
      {children}
    </Heading>
  ),

  p: ({ children }: any) => (
    <Text
      mb={2}
      lineHeight="1.5"
    >
      {children}
    </Text>
  ),

  ul: ({ children }: any) => (
    <Box
      as="ul"
      pl={5}
      mb={2}
    >
      {children}
    </Box>
  ),

  ol: ({ children }: any) => (
    <Box
      as="ol"
      pl={5}
      mb={2}
    >
      {children}
    </Box>
  ),

  li: ({ children }: any) => (
    <Box
      as="li"
      mb={1}
      lineHeight="1.45"
    >
      {children}
    </Box>
  ),

  strong: ({ children }: any) => (
    <Text
      as="span"
      fontWeight="bold"
    >
      {children}
    </Text>
  ),

  em: ({ children }: any) => (
    <Text
      as="span"
      fontStyle="italic"
    >
      {children}
    </Text>
  ),

  // =========================
  // TABLE SUPPORT
  // =========================

  table: ({ children }: any) => (
    <Box
      width="100%"
      overflowX="auto"
      mb={3}
      borderWidth="1px"
      borderColor="gray.200"
      borderRadius="md"
    >
      <Box
        as="table"
        width="100%"
        sx={{ borderCollapse: "collapse" }}
        fontSize="sm"
      >
        {children}
      </Box>
    </Box>
  ),

  thead: ({ children }: any) => (
    <Box
      as="thead"
      bg="gray.50"
    >
      {children}
    </Box>
  ),

  tbody: ({ children }: any) => (
    <Box as="tbody">
      {children}
    </Box>
  ),

  tr: ({ children }: any) => (
    <Box
      as="tr"
      borderBottomWidth="1px"
      borderColor="gray.200"
      _last={{
        borderBottomWidth: 0,
      }}
    >
      {children}
    </Box>
  ),

  th: ({ children }: any) => (
    <Box
      as="th"
      textAlign="left"
      fontWeight="semibold"
      color="gray.700"
      px={3}
      py={2}
      borderRightWidth="1px"
      borderColor="gray.200"
      _last={{
        borderRightWidth: 0,
      }}
    >
      {children}
    </Box>
  ),

  td: ({ children }: any) => (
    <Box
      as="td"
      px={3}
      py={2}
      color="gray.700"
      borderRightWidth="1px"
      borderColor="gray.200"
      verticalAlign="top"
      _last={{
        borderRightWidth: 0,
      }}
    >
      {children}
    </Box>
  ),
};

// =========================
// MARKDOWN THEME COLORS
// =========================


const faqData = [
  {
    question: "What does this online practice test platform include?",
    answer:
      "The platform includes full-length Mock Exams, topic-based practice, timed and untimed assessments, detailed explanations, and performance analytics across multiple exams such as NAPLAN, Selective School Tests, OC, HAST, and scholarship-style assessments.",
  },
  {
    // ===== [FAQ ORDER FIX] Practice Test attempts explained BEFORE Mock Exam is introduced =====
    question: "Can I attempt practice question sets more than once, and in Timed or Untimed mode?",
    answer:
      "Yes. Practice question sets can be attempted as many times as you like, in either Timed mode — to build exam-day speed and composure — or Untimed mode, to focus purely on accuracy and understanding. Questions and answer choices are reshuffled on each attempt, so you build genuine understanding rather than memorising a sequence.",
  },
  {
    question: "Which exams can students prepare for on this platform?",
    answer:
      "Students can prepare for NAPLAN, Selective Entrance Tests, Opportunity Class (OC), HAST, scholarship exams, and other Australian academic competitive assessments.",
  },
  {
    question: "What question formats does Eduvic Practice support?",
    answer:
      "Beyond standard multiple choice, the platform supports Cloze Dropdown and Cloze Gapfill questions, multi-question Extract-based sets, and questions with rich image and diagram support — reflecting the actual variety of formats used in real selective entry and competitive exams, not a simplified subset.",
  },
  {
    question: "Are the practice tests similar to real exam conditions?",
    answer:
      "Yes. All tests are designed to closely replicate real exam structure, question styles, timing, and difficulty progression.",
  },
  {
    question: "Are the tests aligned with the Australian Curriculum and exam standards?",
    answer:
      "Yes. The content is developed with reference to current Australian Curriculum expectations and modern assessment frameworks, ensuring relevance to real exam standards and question types.",
  },
  {
    question: "Do students get explanations for answers?",
    answer:
      "Yes. Every test includes detailed explanations so students can understand mistakes, improve reasoning, and strengthen core concepts instead of just memorising answers.",
  },
  {
    // ===== [FAQ ORDER FIX] Mock Exam now introduced AFTER Practice Test attempts are already understood =====
    question: "What is a Mock Exam, and how is it different from regular practice?",
    answer:
      "A Mock Exam is a full-length, single-attempt simulation of the real exam, sat under real exam timing with scheduled breaks between sections. This is different from your practice question sets, which — as above — you can attempt as many times as you like. A Mock Exam gives one attempt only, so it functions as a genuine readiness check rather than another practice session — save it for when you feel properly prepared.",
  },
  {
    question: "Why do Mock Exams appear as separate \"Component A\" and \"Component B\" entries?",
    answer:
      "A Mock Exam is logically one exam made up of two parts: an Objective Test (Maths, Reading, Quantitative and Verbal Reasoning) and a Writing Test. Because the Writing Test is marked manually by Eduvic and takes a few business days, it's kept as a separate component so your Objective Test result is available immediately rather than being held up waiting on writing evaluation. You'll see this reflected as, for example, \"Mock Exam Set 1 — Component A\" and \"Mock Exam Set 1 — Component B\" both before and after login, but they belong to the same Mock Exam.",
  },
  {
    question: "How can parents track a student's progress?",
    answer:
      "Eduvic does not currently offer a separate parent login. Parents are welcome to accompany their child when logging in to review progress together. Within the student's account, you'll find: an Improvement Trend graph tracking performance across each Practice Test over time; and, for any individual attempt, the overall score and result, topic-level performance analytics, and question-level details with full explanations for every question attempted.",
  },
  {
    question: "Whose email address should be used to register, and can siblings share an account?",
    answer:
      "We recommend registering with the student's own email address, as this is where support queries are handled and where manually marked Writing Test results are sent. If more than one child in a family will be using the platform, each student should register with their own separate account and email address, since only one practice attempt or exam can be in progress at any given time on an account.",
  },
  {
    question: "Is this platform suitable for independent learning at home?",
    answer:
      "Yes. The platform is designed for independent use while also supporting tutoring, classroom learning, and structured academic preparation programs.",
  },
  {
    // ===== [FREE TEST CORRECTION] "sample test" / "free trial" language replaced with the actual product: a Free Practice Test package, 7-day validity =====
    question: "Is a free test available before subscribing?",
    answer:
      "Yes. Each exam domain includes a Free Practice Test package, valid for 7 days from activation, with one full-length practice test for each subject. This lets students and parents experience the platform before enrolling in a full preparation program.",
  },
];

useEffect(() => {
  document.title =
    "Eduvic Practice Platform | Selective Entry, NAPLAN, ACER, Edutest & HAST";

  const description =
  "Realistic practice tests and mock exams for Selective Entry (Victoria and NSW), NAPLAN, ACER, Edutest and HAST, with detailed solutions and analytics.";

  let meta = document.querySelector(
    "meta[name='description']"
  ) as HTMLMetaElement | null;

  if (!meta) {
    meta = document.createElement("meta");
    meta.name = "description";
    document.head.appendChild(meta);
  }

  meta.content = description;
}, []);

  return (
   <PublicLayout>
             {/* Image Band */}
{/* Hero Section */}
  <Box 
    as="section" 
    height={{ base: "72vh", md: "68vh" }}
    bgImage={bandpic}
    bgSize="cover" 
    bgPos="center"
    position="relative"
  >

    {/* LEFT Gradient Overlay for readability */}
    <Box 
      position="absolute" 
      top="0" 
      left="0" 
      width="100%" 
      height="100%" 
      bgGradient="linear(to-r, rgba(0,0,0,0.65), rgba(0,0,0,0.25), rgba(0,0,0,0))"
      zIndex="1"
    />

    <Box
      position="relative"
      zIndex="2"
      height="100%"
      display="flex"
      alignItems="center"
      px={{ base: 6, md: 16 }}
    >
      <VStack 
        align="flex-start"
        spacing={6}
        maxW="700px"
      >
        {/* Headline */}
        <Heading 
          color="white" 
          size="2xl"
          lineHeight="1.2"
        >
          Eduvic Practice Tests, Books & Courses
        </Heading>

        {/* Subtext */}
        <Text 
          color="gray.100"
          fontSize="lg"
          lineHeight="1.6"
        >
          Structured preparation for Selective Entry, NAPLAN, and Scholarship exams — 
          built with real exam patterns, timed practice, and detailed solutions.
        </Text>

        {/* CTA Buttons */}
        <Box display="flex" gap={4} flexWrap="wrap">
          
          {/* Primary CTA */}
          <Box
            as="button"
            bg="blue.600"
            color="white"
            px={8}
            py={3}
            rounded="md"
            fontWeight="bold"
            boxShadow="md"
            _hover={{ bg: "blue.700", transform: "translateY(-2px)" }}
            transition="all 0.2s"
            onClick={() => {
              const element = document.getElementById("categories-section");
              if (element) {
                const yOffset = -80;
                const yPosition =
                  element.getBoundingClientRect().top + window.scrollY + yOffset;
                window.scrollTo({ top: yPosition, behavior: "smooth" });
              }
            }}
          >
            Explore Practice Tests
          </Box>

          {/* Secondary CTA */}
          <Box
            as="button"
            bg="purple.600"
            color="white"
            px={8}
            py={3}
            rounded="md"
            fontWeight="bold"
            backdropFilter="blur(6px)"
            _hover={{ bg: "purple.700", transform: "translateY(-2px)" }}
            transition="all 0.2s"
            onClick={() => navigate("/practice/free-resources")}
          >
            Start Free Practice Test
          </Box>

        </Box>

      </VStack>
    </Box>
  </Box>

  {/* Trust Strip */}
  <Box 
    bg={theme === "light" ? "gray.50" : "gray.900"} 
    py={{ base: 3, md: 4 }}
    borderTop="1px solid"
    borderBottom="1px solid"
    borderColor={theme === "light" ? "gray.200" : "gray.700"}
  >
    <SimpleGrid 
      columns={{ base: 1, sm: 2, md: 3 }} 
      maxW="1200px" 
      mx="auto" 
      px={{ base: 4, md: 6 }} 
      spacing={{ base: 2, md: 3 }}
    >
      {[
        // ===== [MOCK EXAM VISIBILITY] new trust strip item =====
        { icon: "✔", text: "Real exam patterns" },
        { icon: "🎓", text: "Full-length Mock Exams, incl. tutor-marked writing" },
        { icon: "⏱", text: "Timed practice & detailed solutions" },
        { icon: "📊", text: "Topic-wise detailed analytics" },
        { icon: "🔁", text: "Unlimited attempts" },
        { icon: "🎯", text: "Aligned with Australian exams" },
        { icon: "📈", text: "Progressive difficulty levels" },
      ].map((item, i) => (
        <HStack 
          key={i} 
          spacing={2} 
          align="center"
          justify="flex-start"
        >
          <Text fontSize="sm">{item.icon}</Text>
          <Text 
            fontSize="sm" 
            fontWeight="medium"
            color={theme === "light" ? "gray.700" : "gray.300"}
          >
            {item.text}
          </Text>
        </HStack>
      ))}
    </SimpleGrid>
  </Box>
 {/* Master Promo */}
  {masterPromo?.is_active && (
  <Box maxW="1200px" mx="auto" my={8} px={6}>
    <Box
      bg={theme === "light" ? "orange.50" : "orange.900"}
      border="2px solid"
      borderColor="orange.300"
      borderRadius="2xl"
      p={{ base: 6, md: 8 }}
      textAlign="center"
      shadow="md"
    >
      <Heading size="lg" mb={2} color={theme === "light" ? "orange.700" : "orange.200"}>
        {masterPromo.headline}
      </Heading>

      {masterPromo.text && (
        <Text color={theme === "light" ? "gray.700" : "gray.200"} mb={masterPromo.promo_coupon_code ? 4 : 0}>
          {masterPromo.text}
        </Text>
      )}

      {masterPromo.promo_coupon_code && (
        <HStack justify="center" spacing={3} mt={2}>
          <Box
            border="2px dashed"
            borderColor="orange.400"
            borderRadius="md"
            px={5}
            py={2}
            bg={theme === "light" ? "white" : "gray.800"}
          >
            <Text fontWeight="bold" fontSize="lg" letterSpacing="wide">
              {masterPromo.promo_coupon_code}
            </Text>
          </Box>
          <Button size="sm" colorScheme="orange" onClick={() => handleCopyCoupon(masterPromo.promo_coupon_code!)}>
            Copy Code
          </Button>
        </HStack>
      )}
    </Box>
  </Box>
)}


{/* render code for Categories and within the categories for each of the domains */}
<Box py={10} px={6} id="categories-section">
  {/* Section Heading */}
  <VStack mb={10} spacing={3}>
    <Heading size="xl" textAlign="center">
      Eduvic Practice Test Categories
    </Heading>
    <Text textAlign="center" color="gray.500">
      Choose your exam and start structured preparation
    </Text>
  </VStack>

  {/* ========================= */}
  {/* BOX 1 – Category Cards */}
  {/* ========================= */}
  <Box
    maxW="1600px"
    mx="auto"
    
    rounded="2xl"
    overflow="hidden"
    bg={theme === "light" ? "blue.50" : "gray.800"}
    shadow="xl"
  >
    <Box height="8px" bg="blue.500" />
    <Box p={{ base: 6, md: 10 }}>
      <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={12}>
        {categories.map((category, index) => {
          const t = getThemeByIndex(index, theme);
          const isLight = theme === "light";

          // Extract base color name safely (e.g. "blue" from "blue.500")
          const baseColor = t.accent ? t.accent.split('.')[0] : "blue";

          return (
            <Box
              key={category.category_id}
              w="100%"
              minH="200px"
            //  maxH="400px"
              bg={isLight ? t.lightBg : `${baseColor}.800`}
              border="2px solid"
              borderColor={t.border}
              rounded="xl"
              shadow="md"
              cursor="pointer"
              overflow="hidden"
              display="flex"
              flexDirection="column"
              transition="all 0.3s ease"
              _hover={{ transform: "translateY(-6px)", shadow: "xl" }}
              onClick={() => {
                const element = document.getElementById(`category-${category.slug}`);
                if (element) {
                  const yOffset = -80;
                  const yPosition = element.getBoundingClientRect().top + window.scrollY + yOffset;
                  window.scrollTo({ top: yPosition, behavior: "smooth" });
                }
              }}
            >
            {/* Colored Headline Band */}
            <Box position="relative" height="82px">
              <Box
                position="absolute"
                top="30px"
                left={0}
                right={0}
                height="52px"
                bg={isLight ? `${baseColor}.300` : `${baseColor}.600`}
              />
              <Box
                position="absolute"
                top="30px"
                left={0}
                right={0}
                height="52px"
                display="flex"
                alignItems="center"
                px={6}
                zIndex={1}
              >
                <Heading
                  size="md"
                  color={isLight ? "gray.800" : "white"}
                  fontWeight="semibold"
                >
                  {category.hero_headline || category.name}
                </Heading>
              </Box>
            </Box>

            <Box p={2} flex="1" display="flex" flexDirection="column">
              {category.description && (
                <Box fontSize="sm" color={isLight ? "gray.600" : "gray.200"}>
                  <ReactMarkdown
                            remarkPlugins={[remarkGfm]}
                            components={markdownComponents}
                          >
                    {category.description}
                  </ReactMarkdown>
                </Box>   
              )}

                {/* CTA BUTTON */}
{/* CTA pinned to bottom */}
<Box mt="auto">
  <Button
    width="full"
    borderRadius="lg"
    fontWeight="semibold"
    bg={isLight ? `${baseColor}.500` : `${baseColor}.600`}
    color="white"
    _hover={{
      bg: isLight ? `${baseColor}.600` : `${baseColor}.500`,
    }}
    _active={{
      bg: isLight ? `${baseColor}.700` : `${baseColor}.400`,
    }}
    onClick={(e) => {
      e.stopPropagation();

      const element = document.getElementById(
        `category-${category.slug}`
      );

      if (element) {
        const yOffset = -80;

        const yPosition =
          element.getBoundingClientRect().top +
          window.scrollY +
          yOffset;

        window.scrollTo({
          top: yPosition,
          behavior: "smooth",
        });
      }
    }}
  >
    Learn More
  </Button>
</Box>
            </Box>
              
            </Box>
          );
        })}
      </SimpleGrid>
    </Box>
  </Box>

</Box>


  {/* Why Eduvic */}
  <Box
    py={2}
    px={6}
  >

    {/* SECTION HEADER */}
    <VStack spacing={3} mb={10}>
      <Heading size="xl" textAlign="center">
        Why Eduvic?
      </Heading>
    </VStack>

      <Box
        maxW="1600px"
        mx="auto"
      //  p={12}
        
        rounded="2xl"
        overflow="hidden"
        bg={theme === "light" ? "pink.50" : "pink.700"}
        shadow="xl"
      >
        <Box height="8px" bg="pink.500" />
        <Box p={{ base: 6, md: 10 }}>
        {/* CONTENT */}
        <VStack
          maxW="1600px"
          mx="auto"
          spacing={10}
          align="stretch"
        >

        {/* INTRO */}
        <VStack
          spacing={6}
          align="start"
        >

          <Text
            fontSize={{ base: "lg", md: "xl" }}
            lineHeight="1.9"
            fontWeight="semibold"
            color={theme === "light" ? "gray.700" : "gray.100"}
          >
            Eduvic provides a structured, exam-focused learning platform
            designed specifically for Australian students preparing for
            competitive assessments.
          </Text>

          <VStack
            align="start"
            spacing={4}
            width="100%"
          >

            {/* ===== [MOCK EXAM VISIBILITY] rewritten to name the format explicitly, plus one new dedicated bullet START ===== */}
            <HStack align="start" spacing={3}>
              <Icon as={FaCheckCircle} color="blue.500" mt={1} />
              <Text lineHeight="1.9">
                Full-length Mock Exams — a genuine, one-attempt dry run with real exam
                timing, scheduled breaks, and a separately tutor-marked Writing component.
              </Text>
            </HStack>

            <HStack align="start" spacing={3}>
              <Icon as={FaCheckCircle} color="blue.500" mt={1} />
              <Text lineHeight="1.9">
                Every question format the real exam uses — including Cloze Dropdown,
                Cloze Gapfill, and multi-question Extract-based sets, not just standard
                multiple choice.
              </Text>
            </HStack>
            {/* ===== [MOCK EXAM VISIBILITY] rewritten to name the format explicitly, plus one new dedicated bullet END ===== */}

            <HStack align="start" spacing={3}>
              <Icon as={FaChartLine} color="blue.500" mt={1} />
              <Text lineHeight="1.9">
                Detailed analytics and performance tracking for measurable improvement.
              </Text>
            </HStack>

            <HStack align="start" spacing={3}>
              <Icon as={FaClock} color="blue.500" mt={1} />
              <Text lineHeight="1.9">
                Timed assessments that improve speed, concentration, and exam readiness.
              </Text>
            </HStack>

            <HStack align="start" spacing={3}>
              <Icon as={FaBrain} color="blue.500" mt={1} />
              <Text lineHeight="1.9">
                Step-by-step explanations that strengthen reasoning and core concepts.
              </Text>
            </HStack>

            <HStack align="start" spacing={3}>
              <Icon as={FaLaptopCode} color="blue.500" mt={1} />
              <Text lineHeight="1.9">
                Independent online learning designed for modern digital assessment environments.
              </Text>
            </HStack>

          </VStack>

        </VStack>

          {/* FEATURE GRID */}
          {/* FEATURE GRID */}
          <SimpleGrid
            columns={{ base: 1, md: 2 }}
            spacing={6}
          >

            {/* ===== [MOCK EXAM VISIBILITY] moved to front of grid (previously appended at the end) START ===== */}
            <HStack
              align="start"
              spacing={4}
              bg={theme === "light" ? "white" : "gray.800"}
              p={5}
              borderRadius="xl"
              shadow="sm"
            >
              <Icon
                as={FaUserGraduate}
                boxSize={6}
                color="blue.500"
                mt={1}
              />

              <Box>
                <Text fontWeight="bold" mb={1}>
                  Full-Length Mock Exams
                </Text>

                <Text color="gray.600">
                  A single-sitting Objective Test scored instantly, plus a
                  separately tutor-marked Writing Test — one genuine, one-attempt
                  dry run of the real exam.
                </Text>
              </Box>
            </HStack>

            <HStack
              align="start"
              spacing={4}
              bg={theme === "light" ? "white" : "gray.800"}
              p={5}
              borderRadius="xl"
              shadow="sm"
            >
              <Icon
                as={FaRoute}
                boxSize={6}
                color="blue.500"
                mt={1}
              />

              <Box>
                <Text fontWeight="bold" mb={1}>
                  Every Question Format
                </Text>

                <Text color="gray.600">
                  Cloze Dropdown, Cloze Gapfill, multi-question Extract sets and
                  image-rich questions — not just standard multiple choice.
                </Text>
              </Box>
            </HStack>
            {/* ===== [MOCK EXAM VISIBILITY] END ===== */}

            <HStack
              align="start"
              spacing={4}
              bg={theme === "light" ? "white" : "gray.800"}
              p={5}
              borderRadius="xl"
              shadow="sm"
            >
              <Icon
                as={FaBullseye}
                boxSize={6}
                color="blue.500"
                mt={1}
              />

              <Box>
                <Text fontWeight="bold" mb={1}>
                  Real Exam-Style Practice
                </Text>

                <Text color="gray.600">
                  Questions designed to reflect modern Australian
                  exam formats, structure, and difficulty levels.
                </Text>
              </Box>
            </HStack>

            <HStack
              align="start"
              spacing={4}
              bg={theme === "light" ? "white" : "gray.800"}
              p={5}
              borderRadius="xl"
              shadow="sm"
            >
              <Icon
                as={FaClock}
                boxSize={6}
                color="blue.500"
                mt={1}
              />

              <Box>
                <Text fontWeight="bold" mb={1}>
                  Timed Assessment Experience
                </Text>

                <Text color="gray.600">
                  Simulated exam conditions to improve
                  speed, concentration, and time management.
                </Text>
              </Box>
            </HStack>

            <HStack
              align="start"
              spacing={4}
              bg={theme === "light" ? "white" : "gray.800"}
              p={5}
              borderRadius="xl"
              shadow="sm"
            >
              <Icon
                as={FaBrain}
                boxSize={6}
                color="blue.500"
                mt={1}
              />

              <Box>
                <Text fontWeight="bold" mb={1}>
                  Detailed Learning Support
                </Text>

                <Text color="gray.600">
                  Step-by-step explanations help students
                  understand concepts and strengthen reasoning.
                </Text>
              </Box>
            </HStack>

            <HStack
              align="start"
              spacing={4}
              bg={theme === "light" ? "white" : "gray.800"}
              p={5}
              borderRadius="xl"
              shadow="sm"
            >
              <Icon
                as={FaChartLine}
                boxSize={6}
                color="blue.500"
                mt={1}
              />

              <Box>
                <Text fontWeight="bold" mb={1}>
                  Performance Analytics
                </Text>

                <Text color="gray.600">
                  Track accuracy, progress, strengths,
                  and improvement opportunities over time.
                </Text>
              </Box>
            </HStack>

            <HStack
              align="start"
              spacing={4}
              bg={theme === "light" ? "white" : "gray.800"}
              p={5}
              borderRadius="xl"
              shadow="sm"
            >
              <Icon
                as={FaLaptopCode}
                boxSize={6}
                color="blue.500"
                mt={1}
              />

              <Box>
                <Text fontWeight="bold" mb={1}>
                  Modern Digital Practice
                </Text>

                <Text color="gray.600">
                  Interactive online assessments built for
                  independent learning and structured preparation.
                </Text>
              </Box>
            </HStack>

            <HStack
              align="start"
              spacing={4}
              bg={theme === "light" ? "white" : "gray.800"}
              p={5}
              borderRadius="xl"
              shadow="sm"
            >
              <Icon
                as={FaCheckCircle}
                boxSize={6}
                color="blue.500"
                mt={1}
              />

              <Box>
                <Text fontWeight="bold" mb={1}>
                  Curriculum-Aligned Content
                </Text>

                <Text color="gray.600">
                  Practice material aligned with Australian
                  curriculum expectations and assessment standards.
                </Text>
              </Box>
            </HStack>

          </SimpleGrid>

        </VStack>
        </Box>

        </Box>

  </Box>


<Box py={10} px={6} id="categories-details">
  {/* ============================== */}
  {/* BOX 2 – Detailed Sections + Domain Cards */}
  {/* ============================== */}
  <VStack spacing={16} align="stretch" maxW="1600px" mx="auto" px={{ base: 4, md: 6 }}>
    {categories.map((category, index) => {
      const t = getThemeByIndex(index, theme);
      const isLight = theme === "light";
      const baseColor = t.accent ? t.accent.split('.')[0] : "blue";

      // A category with nothing live yet still gets its full long
      // description (good for both readers and SEO), but the domain
      // grid -- a wall of repeated "Coming Soon" cards -- is replaced
      // with a single badge + count. Purely computed from existing
      // domain data, so this flips automatically as domains go live.
      const hasAnyAvailableDomain = category.domains.some(
        (d) => !d.show_as_coming_soon
      );

      return (
        <Box key={category.category_id} id={`category-${category.slug}`}>
        
          {/* Outside Heading */}
          {/* Outside Heading */}
          <Flex
            align="center"
            wrap="wrap"
            gap={3}
            mb={4}
            px={{ base: 2, md: 2 }}
          >
            <Heading
              size="lg"
              borderLeft="4px solid"
              borderColor={t.strip}
              pl={3}
            >
              {category.hero_headline || category.name}
            </Heading>

            {!hasAnyAvailableDomain && (
              <Badge
                colorScheme={isLight ? "orange" : "purple"}
                px={3}
                py={1}
                borderRadius="full"
                fontSize="0.7rem"
                textTransform="uppercase"
                whiteSpace="nowrap"
              >
                Coming Soon
              </Badge>
            )}
          </Flex>

          {category.hero_text && (
            <Text
              px={{ base: 2, md: 2 }}
              mb={4}
              fontSize="lg"
              fontWeight="bold"
              color="gray.600"
              maxW="3xl"
            >
              {category.hero_text}
            </Text>
          )}

          {/* Category Promo */}
          {category.promo_active && category.promo_headline && (
            <Box mb={4} px={{ base: 2, md: 2 }}>
              <Box
                bg={isLight ? "orange.50" : "orange.800"}
                border="1px solid"
                borderColor="orange.300"
                borderRadius="lg"
                p={4}
              >
                <Text fontWeight="bold" color={isLight ? "orange.700" : "orange.100"}>
                  {category.promo_headline}
                </Text>

                {category.promo_text && (
                  <Text fontSize="sm" mt={1} color={isLight ? "gray.700" : "gray.200"}>
                    {category.promo_text}
                  </Text>
                )}

                {category.promo_coupon_code && (
                  <HStack mt={3} spacing={3}>
                    <Box border="2px dashed" borderColor="orange.400" borderRadius="md" px={4} py={1} bg={isLight ? "white" : "gray.900"}>
                      <Text fontWeight="bold" letterSpacing="wide">{category.promo_coupon_code}</Text>
                    </Box>
                    <Button size="xs" colorScheme="orange" onClick={() => handleCopyCoupon(category.promo_coupon_code!)}>
                      Copy Code
                    </Button>
                  </HStack>
                )}
              </Box>
            </Box>
          )}

          {/* Main Content Box */}
          <Box
           // border="2px solid"
            borderColor={t.border}
            bg={isLight ? t.lightBg : `${baseColor}.900`}
            rounded="2xl"
            overflow="hidden"
            shadow="xl"
          >
            <Box height="6px" bg={t.strip} />

            <Box p={{ base: 5, md: 8 }}>

                        <Box
                      p={4}
                    //  shadow={"md"}
                   //   bg={isLight ? t.lightBg : `${baseColor}.900`}
                      //border="1px solid"
                      borderColor={t.border}
                      rounded="xl"
                      overflow="hidden"
                    >

              <B2CMarkdownLongText content={category?.long_description} textAlign="left" />

              </Box>

              {/* Domains Grid -- only rendered once at least one domain
                  in this category is live; otherwise a single line
                  replaces what would be a grid of repeated "Coming Soon"
                  cards. */}
              {hasAnyAvailableDomain ? (
            <SimpleGrid
              mt={8}
              minChildWidth="280px"
              spacing={8}
              
            >

                {category.domains.map((domain, dIndex) => {

                  const dt = getThemeByIndex(index + dIndex + 2, theme);

                  const domainIsLight = theme === "light";

                  const domainBaseColor = dt.accent
                    ? dt.accent.split('.')[0]
                    : "blue";

                  const isComingSoon = domain.show_as_coming_soon;

                  return (

                    <Box
                      key={domain.domain_id}
                        minW="280px"
                        maxW="360px"
                        w="100%"
                        minH="620px"
                      bg={
                        domainIsLight
                          ? dt.lightBg
                          : `${domainBaseColor}.800`
                      }
                      border="1px solid"
                      borderColor={
                        isComingSoon
                          ? (domainIsLight ? "orange.300" : "purple.500")
                          : dt.border
                      }
                      rounded="xl"
                      shadow={isComingSoon ? "sm" : "md"}
                      cursor={isComingSoon ? "default" : "pointer"}
                      overflow="hidden"
                      display="flex"
                      flexDirection="column"
                      transition="all 0.3s ease"
                      opacity={isComingSoon ? 0.88 : 1}
                      _hover={
                        isComingSoon
                          ? {}
                          : {
                              transform: "translateY(-6px)",
                              shadow: "xl",
                            }
                      }
                      onClick={() => {
                        if (!isComingSoon) {
                          navigate(`/practice/${domain.slug}`);
                        }
                      }}
                    >

                      {/* ===================================== */}
                      {/* HEADLINE STRIP */}
                      {/* ===================================== */}

                      <Box
                        position="relative"
                        height="82px"
                      >

                        {/* Decorative strip */}
                        <Box
                          position="absolute"
                          top="30px"
                          left={0}
                          right={0}
                          height="52px"
                          bg={
                            domainIsLight
                              ? `${domainBaseColor}.300`
                              : `${domainBaseColor}.600`
                          }
                        />

                        {/* Headline */}
                        <Flex
                          position="absolute"
                          top="30px"
                          left={0}
                          right={0}
                          height="52px"
                          align="center"
                          justify="space-between"
                          px={5}
                          zIndex={1}
                        >

                          <Heading
                            size="sm"
                            color={
                              domainIsLight
                                ? "gray.800"
                                : "white"
                            }
                            fontWeight="semibold"
                            pr={3}
                          >
                            {domain.name || domain.hero_headline}
                          </Heading>

                          {/* STATUS BADGE */}

                          {isComingSoon ? (

                            <Badge
                              colorScheme={
                                domainIsLight
                                  ? "orange"
                                  : "purple"
                              }
                              px={3}
                              py={1}
                              borderRadius="full"
                              fontSize="0.68rem"
                              textTransform="uppercase"
                              whiteSpace="nowrap"
                            >
                              Coming Soon
                            </Badge>

                          ) : (

                            <Badge
                              colorScheme="green"
                              px={3}
                              py={1}
                              borderRadius="full"
                              fontSize="0.68rem"
                              textTransform="uppercase"
                              whiteSpace="nowrap"
                            >
                              Available Now
                            </Badge>

                          )}

                        </Flex>

                      </Box>
                      {/* ===================================== */}
                      {/* CARD CONTENT */}
                      {/* ===================================== */}

                      <Box
                        p={5}
                        flex="1"
                        display="flex"
                        flexDirection="column"
                      >

                        {/* DESCRIPTION */}

                        <Box
                          flex="1"
                          fontSize="sm"
                          color={
                            domainIsLight
                              ? "gray.700"
                              : "gray.200"
                          }
                        >

                          {domain.description && (

                            <ReactMarkdown
                              remarkPlugins={[remarkGfm]}
                              components={markdownComponents}
                            >
                              {domain.description}
                            </ReactMarkdown>

                          )}

                        </Box>

                        {/* ===================================== */}
                        {/* CTA BUTTON */}
                        {/* ===================================== */}

                        <Button
                          mt={6}
                          width="100%"
                          colorScheme={
                            isComingSoon
                              ? (domainIsLight ? "orange" : "purple")
                              : domainBaseColor
                          }
                          variant={
                            isComingSoon
                              ? "outline"
                              : "solid"
                          }
                          isDisabled={isComingSoon}
                          cursor={isComingSoon ? "default" : "pointer"}
                          onClick={(e) => {

                            e.stopPropagation();

                            if (!isComingSoon) {
                              navigate(`/practice/${domain.slug}`);
                            }

                          }}
                        >

                          {isComingSoon
                            ? "Launching Soon"
                            : "Explore Package"}

                        </Button>

                      </Box>

                    </Box>

                  );

                 })}

              </SimpleGrid>
              ) : (
                <>
                 <Divider borderColor="gray.500" />
                <Text
                  mt={8}
                  fontSize="sm"
                  color={isLight ? "gray.500" : "gray.400"}
                >
                  {category.domains.length} exam package{category.domains.length !== 1 ? "s" : ""} in
                  development for this category.
                </Text>
                </>
              )}
            </Box>
          </Box>
        </Box>
      );
    })}
  </VStack>
</Box>

{/* ========================================= */}
{/* HOW EDUVIC WORKS */}
{/* ========================================= */}

    <Box
      py={{ base: 14, md: 20 }}
      px={{ base: 6, md: 10 }}
    >

      <VStack
        spacing={4}
        textAlign="center"
        mb={14}
      >

        <Heading size="2xl">
          How Eduvic Works
        </Heading>

        <Text
          fontSize="xl"
          fontWeight="semibold"
          color="gray.600"
          maxW="4xl"
        >
          From Registration to Exam Confidence — In 5 Simple Steps
        </Text>

        <Text
          color="gray.500"
          maxW="3xl"
          lineHeight="1.8"
        >
          Structured preparation designed for busy families,
          independent learners, and students preparing for
          competitive school entrance and scholarship exams.
        </Text>

      </VStack>

      {/* ===== [MOCK EXAM VISIBILITY] xl columns changed 4 → 5 to fit the new step evenly ===== */}
      <SimpleGrid
        columns={{ base: 1, md: 2, xl: 5 }}
        spacing={8}
        maxW="1600px"
        mx="auto"
      >

        {/* STEP 1 */}

        <Box
          bg={useColorModeValue("white", "gray.800")}
          borderRadius="2xl"
          borderTop="8px solid"
          borderColor="blue.400"
          p={8}
          shadow="xl"
          transition="all 0.3s ease"
          _hover={{
            transform: "translateY(-6px)",
            shadow: "2xl",
          }}
        >

          <Text
            fontSize="5xl"
            fontWeight="bold"
            color="blue.400"
            mb={4}
          >
            1
          </Text>

          <Heading
            size="md"
            mb={4}
          >
            Choose Your Exam
          </Heading>

          <Text
            color="gray.600"
            lineHeight="1.8"
          >
            Select the exam pathway that matches your goals —
            NAPLAN, Selective Entry, Scholarship Exams,
            OC, ACER, Edutest and more.
            Explore free practice resources before
            committing to a full package.
          </Text>

        </Box>

        {/* STEP 2 */}

        <Box
          bg={useColorModeValue("white", "gray.800")}
          borderRadius="2xl"
          borderTop="8px solid"
          borderColor="teal.400"
          p={8}
          shadow="xl"
          transition="all 0.3s ease"
          _hover={{
            transform: "translateY(-6px)",
            shadow: "2xl",
          }}
        >

          <Text
            fontSize="5xl"
            fontWeight="bold"
            color="teal.400"
            mb={4}
          >
            2
          </Text>

          <Heading
            size="md"
            mb={4}
          >
            Practice Timed Mock Tests
          </Heading>

          <Text
            color="gray.600"
            lineHeight="1.8"
          >
            Attempt timed mock tests designed to reflect
            real exam structure and difficulty levels.
            Build confidence, pacing, and exam familiarity
            through structured practice.
          </Text>

        </Box>

        {/* STEP 3 */}

        <Box
          bg={useColorModeValue("white", "gray.800")}
          borderRadius="2xl"
          borderTop="8px solid"
          borderColor="purple.400"
          p={8}
          shadow="xl"
          transition="all 0.3s ease"
          _hover={{
            transform: "translateY(-6px)",
            shadow: "2xl",
          }}
        >

          <Text
            fontSize="5xl"
            fontWeight="bold"
            color="purple.400"
            mb={4}
          >
            3
          </Text>

          <Heading
            size="md"
            mb={4}
          >
            Review Performance & Improve
          </Heading>

          <Text
            color="gray.600"
            lineHeight="1.8"
          >
            Access explanations, analytics, and section-level
            performance insights to identify strengths and
            focus preparation on areas needing improvement.
          </Text>

        </Box>

        {/* ===== [MOCK EXAM VISIBILITY] new Step 4 inserted before the closing step START ===== */}
        {/* STEP 4 */}

        <Box
          bg={useColorModeValue("white", "gray.800")}
          borderRadius="2xl"
          borderTop="8px solid"
          borderColor="pink.400"
          p={8}
          shadow="xl"
          transition="all 0.3s ease"
          _hover={{
            transform: "translateY(-6px)",
            shadow: "2xl",
          }}
        >

          <Text
            fontSize="5xl"
            fontWeight="bold"
            color="pink.400"
            mb={4}
          >
            4
          </Text>

          <Heading
            size="md"
            mb={4}
          >
            Sit a Full Mock Exam
          </Heading>

          <Text
            color="gray.600"
            lineHeight="1.8"
          >
            Once genuinely ready, attempt a full-length Mock Exam under real
            exam timing — an Objective Test scored instantly, plus a Writing
            Test marked by Eduvic, for a true final readiness check.
          </Text>

        </Box>
        {/* ===== [MOCK EXAM VISIBILITY] new Step 4 inserted before the closing step END ===== */}

        {/* STEP 5 (was Step 4) */}

        <Box
          bg={useColorModeValue("white", "gray.800")}
          borderRadius="2xl"
          borderTop="8px solid"
          borderColor="orange.400"
          p={8}
          shadow="xl"
          transition="all 0.3s ease"
          _hover={{
            transform: "translateY(-6px)",
            shadow: "2xl",
          }}
        >

          <Text
            fontSize="5xl"
            fontWeight="bold"
            color="orange.400"
            mb={4}
          >
            5
          </Text>

          <Heading
            size="md"
            mb={4}
          >
            Walk Into The Exam Prepared
          </Heading>

          <Text
            color="gray.600"
            lineHeight="1.8"
          >
            By exam day, students become familiar with
            question styles, exam pacing, and assessment
            patterns through consistent structured preparation.
          </Text>

        </Box>

      </SimpleGrid>

    </Box>

{/* ========================================= */}
{/* SEE THE PLATFORM IN ACTION */}
{/* ========================================= */}

<Box
  py={{ base: 14, md: 20 }}
  px={{ base: 6, md: 10 }}
  bg={theme === "light" ? "gray.50" : "gray.900"}
>

  <VStack spacing={4} textAlign="center" mb={12}>

    <Heading size="2xl">
      See The Platform In Action
    </Heading>

    <Text
      fontSize="xl"
      fontWeight="semibold"
      color="gray.600"
      maxW="4xl"
    >
      A Quick Walkthrough Of What You Get
    </Text>

    <Text
      color="gray.500"
      maxW="3xl"
      lineHeight="1.8"
    >
      Timed and untimed practice modes, real exam-style conditions,
      rich question formats, and detailed performance analytics —
      see it all in under a few minutes.
    </Text>

  </VStack>

  <Box maxW="960px" mx="auto">
    <B2CVideoEmbed
      youtubeId="u24aZ6sTmwg"
      title="Eduvic Practice Platform Walkthrough"
    />
  </Box>

  {/* Optional: feature chips under the video, reinforcing what it shows */}
  <SimpleGrid
    columns={{ base: 2, md: 4 }}
    spacing={4}
    maxW="960px"
    mx="auto"
    mt={8}
  >
    {[
      // ===== [MOCK EXAM VISIBILITY] new chip added, one existing chip reworded for specificity =====
      "Timed & Untimed Modes",
      "Full-Length Mock Exams",
      "Real Exam-Style Conditions",
      "Rich Image & Extract Support",
      "Cloze Dropdown & Gapfill",
      "Detailed Score Breakdown",
      "Explanations Per Question",
      "Topic-Level Performance",
      "Improvement Trends",
    ].map((label, i) => (
      <HStack
        key={i}
        bg={theme === "light" ? "white" : "gray.800"}
        borderRadius="lg"
        p={3}
        spacing={2}
        shadow="sm"
      >
        <Icon as={FaCheckCircle} color="blue.500" boxSize={4} flexShrink={0} />
        <Text fontSize="xs" fontWeight="medium" color={theme === "light" ? "gray.700" : "gray.300"}>
          {label}
        </Text>
      </HStack>
    ))}
  </SimpleGrid>

</Box>

{/* Need More Than Practice? */}
{/* Need More Than Practice? */}

<Box py={2} px={6}>

  <VStack spacing={3} mb={10}>
    <Heading size="xl" textAlign="center">
      Need More Than Practice?
    </Heading>

    <Text
      textAlign="center"
      maxW="900px"
      fontSize="lg"
      color={theme === "light" ? "gray.600" : "gray.300"}
    >
      For families looking for more than independent practice, Eduvic Coaching
      provides personalised online coaching for selected examinations,
      combining expert mentoring, relevant practice, regular assessment and
      ongoing performance review.
    </Text>
  </VStack>

  <Box
    maxW="1600px"
    mx="auto"
    rounded="2xl"
    overflow="hidden"
    bg={theme === "light" ? "purple.50" : "purple.800"}
    shadow="xl"
  >
    <Box height="8px" bg="purple.500" />

    <Box p={{ base: 6, md: 10 }}>

      <VStack spacing={10} align="stretch">

        <Text
          fontSize={{ base: "lg", md: "xl" }}
          lineHeight="1.9"
          fontWeight="semibold"
        >
          Eduvic Practice is designed for independent preparation. Eduvic
          Coaching takes this a step further with personalised learning
          pathways, where students work with an Eduvic mentor through online
          coaching while using Eduvic Practice and the Eduvic Learning Platform
          for structured practice, learning material and assessment.
        </Text>

        <SimpleGrid columns={{ base: 1, md: 2 }} spacing={6}>

          <HStack
            align="start"
            spacing={4}
            bg={theme === "light" ? "white" : "gray.800"}
            p={5}
            borderRadius="xl"
            shadow="sm"
          >
            <Icon
              as={FaUserGraduate}
              boxSize={6}
              color="purple.500"
              mt={1}
            />

            <Box>
              <Text fontWeight="bold" mb={1}>
                Personalised Learning Pathways
              </Text>

              <Text color="gray.600">
                Coaching is shaped around the student's needs and the
                requirements of the selected scholarship or entrance
                examination.
              </Text>
            </Box>
          </HStack>

          <HStack
            align="start"
            spacing={4}
            bg={theme === "light" ? "white" : "gray.800"}
            p={5}
            borderRadius="xl"
            shadow="sm"
          >
            <Icon
              as={FaUsers}
              boxSize={6}
              color="purple.500"
              mt={1}
            />

            <Box>
              <Text fontWeight="bold" mb={1}>
                Online Coaching
              </Text>

              <Text color="gray.600">
                Work directly with an Eduvic mentor through structured online
                coaching sessions focused on the target examination.
              </Text>
            </Box>
          </HStack>

          <HStack
            align="start"
            spacing={4}
            bg={theme === "light" ? "white" : "gray.800"}
            p={5}
            borderRadius="xl"
            shadow="sm"
          >
            <Icon
              as={FaRoute}
              boxSize={6}
              color="purple.500"
              mt={1}
            />

            <Box>
              <Text fontWeight="bold" mb={1}>
                Practice & Assessment
              </Text>

              <Text color="gray.600">
                Continue preparation between coaching sessions with relevant
                Eduvic Practice content and regular assessments through the
                Learning Platform.
              </Text>
            </Box>
          </HStack>

          <HStack
            align="start"
            spacing={4}
            bg={theme === "light" ? "white" : "gray.800"}
            p={5}
            borderRadius="xl"
            shadow="sm"
          >
            <Icon
              as={FaExternalLinkAlt}
              boxSize={6}
              color="purple.500"
              mt={1}
            />

            <Box>
              <Text fontWeight="bold" mb={1}>
                Performance Review
              </Text>

              <Text color="gray.600" mb={4}>
                Practice and assessment results help identify strengths and
                areas requiring further work as preparation progresses.
              </Text>

              <Button
                as="a"
                href="/coaching"
                target="_blank"
                rel="noopener noreferrer"
                colorScheme="purple"
                size="sm"
              >
                Explore Guided Preparation
              </Button>
            </Box>
          </HStack>

        </SimpleGrid>

      </VStack>

    </Box>

  </Box>

</Box>

  {/* FAQs */}
  <Box py={16} px={6}>

    {/* SECTION HEADER */}
    <VStack spacing={3} mb={10}>
      <Heading size="xl" textAlign="center">
        Frequently Asked Questions
      </Heading>
    </VStack>

    {/* CONTENT */}
    <VStack
    spacing={6}
    maxW="1200px"
    mx="auto"
    align="stretch"
  >

      <Accordion allowToggle width="100%">

        {faqData.map((faq, index) => (

          <AccordionItem
            key={index}
            border="1px solid"
            borderColor="gray.200"
            borderRadius="md"
            mb={3}
          >

            <AccordionButton py={4}>

              <HStack flex="1" spacing={3} align="center">

                <Icon
                  as={FaRegLightbulb}
                  color="blue.500"
                  boxSize={4}
                />

                <Box
                  textAlign="left"
                  fontWeight="semibold"
                >
                  {faq.question}
                </Box>

              </HStack>

              <AccordionIcon />

            </AccordionButton>

            <AccordionPanel pb={4} color="gray.600">
              {faq.answer}
            </AccordionPanel>

          </AccordionItem>

        ))}

      </Accordion>

    </VStack>

  </Box>

      </PublicLayout>
);
}

export default B2CLandingPage;